import type { TreeNode } from "../context/types";

/**
 * Collects the IDs of all descendants of a given node in the tree,
 * including the node itself.
 */
export function getDescendantIds({
  nodeId,
  tree,
}: {
  nodeId: string;
  tree: TreeNode[];
}): Set<string> {
  const ids = new Set<string>([nodeId]);
  let added = true;
  while (added) {
    added = false;
    for (const node of tree) {
      if (
        node.parent_photo_id &&
        ids.has(node.parent_photo_id) &&
        !ids.has(node.id)
      ) {
        ids.add(node.id);
        added = true;
      }
    }
  }
  return ids;
}
